import React from 'react';
import * as Styled from './Sidebar.styles';

const Sidebar = ({ className, children }) => (
  <Styled.Sidebar className={`${className || ''}`}>{children}</Styled.Sidebar>
);

export default Sidebar;
